import React from 'react';
import ModalContainer from 'Components/Common/Modal/ModalContainer';
import ModalHeader from 'Components/Common/Modal/ModalHeader';
import ModalBody from 'Components/Common/Modal/ModalBody';

type StopModalProps = {
    isOpen: boolean,
    onCancel: () => void
    handleStop: () => void
}

const ABStopModal = ({ onCancel, handleStop, isOpen }: StopModalProps) => {
    //const abContext = useContext(ABContext);

    return (
        <ModalContainer width='10%' isOpen={isOpen} setOpen={handleStop}>
            <ModalHeader>
                Stop A/B test
            </ModalHeader>
            <ModalBody >
                Do you want to stop the test?
            </ModalBody>
            <div className={`tw-px-3 tw-flex tw-gap-2 tw-justify-end tw-mb-4`}>
                <button onClick={onCancel} className='popup-button-outline'> Cancel</button>
                <button className="popup-button-filled"
                    onClick={handleStop}
                >
                    Yes, stop
                </button>
            </div>
        </ModalContainer >
    );
}

export default ABStopModal;